import { type ReactElement } from 'react'
import * as S from './footer.styled'
import logo from '../../assets/images/logo-positvo.png'
import linkedin from './assets/LinkedIn.svg'
import facebook from './assets/Facebook.svg'
import instagram from './assets/Instagram.svg'
import { Link } from 'react-router-dom'
import { PhoneNumber } from '../phone-number/phone-number'
import { Terms } from './terms'

export function FullFooter (): ReactElement {
  return <>
    <S.Contact>
      <figure>
        <img src={logo} alt="" />
      </figure>
      <div>
        <p>
          Redes sociais
          <Link to="https://br.linkedin.com/company/cartaodetodos" target="_blank" rel="noopener noreferrer"><img src={linkedin} alt="LinkedIn" /></Link>
          <Link to="https://www.instagram.com/cartaodetodosbrasil/" target="_blank" rel="noopener noreferrer"><img src={instagram} alt="Instagram" /></Link>
          <Link to="https://www.facebook.com/cartaodetodosbrasil/" target="_blank" rel="noopener noreferrer"><img src={facebook} alt="Facebook" /></Link>
        </p>
        <div>
          <p>Vendas <Link to="tel:08008800881"><PhoneNumber>0800 880 0881</PhoneNumber></Link></p>
          <p>SAC <Link to="tel:08002838916"><PhoneNumber>0800 283 8916</PhoneNumber></Link></p>
        </div>
      </div>
    </S.Contact>
    <Terms />
    <S.Disclaimer>
      * Cartão de desconto não é plano de saúde, não garante e não se responsabiliza pelos serviços oferecidos e pelo pagamento das despesas, nem assegura desconto em todos os serviços obrigatoriamente garantidos por plano de saúde. Tudo o que o cliente usar ou comprar será por ele pago ao prestador, assegurando-se apenas os preços e descontos que constam na relação de empresas e serviços conveniados disponibilizados no site <Link to="www.cartaodetodos.com.br" target="_blank" rel="noreferrer noopener">www.cartaodetodos.com.br</Link>. O atendimento será em até 15 dias, mediante disponibilidade na clínica. Consulte a clínica parceira para as especialidades disponíveis e condições para marcar as consultas.
    </S.Disclaimer>
  </>
}
